import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useCashList = (page = 1) => useQuery({ queryKey: [`cash-list-${page}`], queryFn: async () => {
    const callback = await API.get(`/cash?page=${page}`)
    return callback?.data
}, staleTime: 1000 * 60, gcTime: 1000 * 60 * 60 * 60 * 24 })

export default useCashList